export function SkeletonGrid({ count = 6 }: { count?: number }) {
  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-card">
          <div className="skeleton-image" />
          <div className="space-y-3 p-4">
            <div className="skeleton-line w-1/3" />
            <div className="skeleton-line w-full" />
            <div className="skeleton-line w-2/3" />
            <div className="flex justify-between pt-2">
              <div className="skeleton-line w-1/4" />
              <div className="skeleton-line h-10 w-10 rounded-lg" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
